/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileProjets2, defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_047: Question = {
  id: 'pres-047-projets-controle-eee',
  oldId: '61',
  title: 'Projets de contrôle des EEE',
  number: '4.9',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 3) return 3;
        if (data >= 2) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileProjets2,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_047__v3: Question = {
  ...question_pres_047,
  title: 'Superficie de contrôle des EEE',
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

export const question_pres_047_v2: Question = question_pres_047;
export const question_pres_047_v3: Question = question_pres_047__v3;
